'use strict';

(function () {
    'use strict';

    angular.module('zp').directive('searchSlider', searchSlider);

    function searchSlider() {
        return {
            restrict: 'E',
            link: link,
            transclude: true,
            replace: true,
            scope: {
                sliderName: '=',
                sliderAlias: '=',
                searchModel: '=',
                sliderType: '=',
                sliderOptions: '=',
                sliderChanged: '=',
                sliderClosed: '=',
                sliderResolution: '=',
                sliderUnit: '='
            },
            templateUrl: 'app/results/filters/search.slider.html'
        };

        function link(scope, iElement, iAttrs, searchModel, $timeout) {
            var jq = angular.element;

            scope.toggleFilterBody = toggleFilterBody;
            scope.showFilterBody = false;
            scope.defaultValuesApplied = true;
            scope.hideDouble = false;
            scope.differentResolution = false;
            scope.showMoney = false;
            scope.showOtherUnits = null;
            scope.min = false;
            scope.max = false;
            scope.exit = false;

            scope.minValue = scope.sliderOptions.floor;
            scope.maxValue = scope.sliderOptions.ceil;
            scope.onSliderChange = onSliderChange;
            scope.resolutionChange = resolutionChange;
            scope.hideDropdownBody = hideDropdownBody;

            var providedCallback = null;

            (function activate() {

                resolutionChange();
                setUnit();
                providedCallback = scope.sliderChanged;
                scope.sliderOptions.onChange = onSliderChange;
                scope.sliderOptions.showSelectionBar = true;
                scope.sliderOptions.noSwitching = true;
                scope.hideDouble = scope.sliderType == 'single';
                scope.$watch('searchModel', function (newVal, oldVal) {
                    if (scope.hideDouble) {
                        setDefaultValue();
                    } else {
                        setDefaultRange();
                    }
                    jq(document).mouseup(function (e) {
                        var container = jq('.filter-body');

                        if (!container.is(e.target) && container.has(e.target).length === 0) {
                            hideDropdownBody();
                            scope.$apply();
                        }
                    });
                });
                $timeout(function () {
                    scope.$broadcast('rzSliderForceRender');
                });
            })();

            function setDefaultRange() {
                if (!!scope.searchModel && scope.searchModel[scope.sliderAlias].length == 2) {
                    scope.minValue = scope.searchModel[scope.sliderAlias][0];
                    scope.maxValue = scope.searchModel[scope.sliderAlias][1];
                }
                checkIfDefaultValuesAreApplied();
            }

            function setDefaultValue() {
                if (!!scope.searchModel && !!scope.searchModel[scope.sliderAlias]) {
                    scope.maxValue = scope.searchModel[scope.sliderAlias];
                }
                checkIfDefaultValuesAreApplied();
            }

            function checkIfDefaultValuesAreApplied() {
                if (scope.hideDouble) {
                    scope.defaultValuesApplied = scope.maxValue == scope.sliderOptions.ceil;
                } else {
                    scope.defaultValuesApplied = scope.minValue == scope.sliderOptions.floor && scope.maxValue == scope.sliderOptions.ceil;
                }
            }

            function setUnit() {
                if (scope.sliderUnit == 'money') {
                    scope.showMoney = true;
                }
            }

            function onSliderChange() {
                if (scope.hideDouble) {
                    scope.searchModel[scope.sliderAlias] = scope.maxValue;
                } else {
                    scope.searchModel[scope.sliderAlias][0] = scope.minValue;
                    scope.searchModel[scope.sliderAlias][1] = scope.maxValue;
                }
                checkIfDefaultValuesAreApplied();
                if (!!providedCallback) {
                    providedCallback();
                }
            }

            function toggleFilterBody() {
                scope.showFilterBody = !scope.showFilterBody;
                if (!!scope.sliderClosed) {
                    scope.sliderClosed();
                }
            }

            function resolutionChange() {
                if (!!scope.sliderResolution) {
                    scope.differentResolution = true;
                }
            }

            function hideDropdownBody(container) {
                scope.showFilterBody = false;
            }
        }
    }
})();